import { ApprovalContainer } from '@retail/calculus/containers';
import { PageLayout, SuspenseWithSentryErrorBoundary } from '@retail/components';
import { Paper } from '@shared/components';

export const ApprovalPage = () => {
  return (
    <PageLayout maxWidth="full" fixedHeight spacing={2}>
      <Paper sx={{ display: 'flex', flexDirection: 'column', p: 0, height: '100%' }}>
        <SuspenseWithSentryErrorBoundary>
          <ApprovalContainer />
        </SuspenseWithSentryErrorBoundary>
      </Paper>
    </PageLayout>
  );
};
